import { h, Component } from 'preact';
import {Button, I18n, Form, Container} from 'components/elements' 
import {PatientSelectCard} from 'components/groups'
import {times} from 'lib/helpers'
import {connect} from 'react-redux'
import style from './style.less'
import dayjs from 'dayjs'
import { PatientActions } from 'actions';

@Form
@connect((state)=>({
	...state
}))
export default class PatientSelectVertical extends Component {
	constructor(){
        super()
        this.state = {
            newPatient: ''
        }
        this.patientsToCreate = this.patientsToCreate.bind(this)
        this.handleNewPatient = this.handleNewPatient.bind(this)
        this.handlePatientSelect = this.handlePatientSelect.bind(this)
        this.handleNewPatientSubmit = this.handleNewPatientSubmit.bind(this)
        this.handleNewPatientCancel = this.handleNewPatientCancel.bind(this)
    }
    
    get newPatientCount(){
        let newPatientCount = this.patients.filter((patient)=>/newPatient/.test(patient.id)).length
        return newPatientCount
    }

    get patients(){
        return Object.values(this.props.patients || {})
    }

    get patientsReversed() {
        const value = [...this.patients]
        value.reverse()
        return value
    }
    
    get appointmentTypes(){
        return Object.values(this.props.appointmentTypes || {}).filter((appType)=>{
            if(appType.userType && ((!(this.props.session || {}).accessToken && appType.userType == 'returning') || ((this.props.session || {}).accessToken && appType.userType == 'new'))){
                return false
            }
            let maxPatients = 1
            if(appType.durations){
                maxPatients = appType.durations.split(',').length 
            }
            if(!this.props.filters.patientCount || this.props.filters.patientCount <= maxPatients){
                return true
            }
            return false
        })
    }

    get appointmentType(){
        return this.props.appointmentTypes[this.props.filters.appointmentTypeID] || {}
    }

    get hasRestrictions(){
        return (this.appointmentType.rules || []).length > 0
    }
    
    get classifications(){
        const classifications = Object.entries(this.props.classifications || {})
            .map(([, _])=> _ )
            .filter((c)=>(_.isNil(c.siblingID) && c.active))
		
		return classifications.map((_)=>({
            name: _.name,
			value: _.id
		}))
    }

    get genders(){
		return Object.values(this.props.genders || {}).map((_)=>({
            name: _.name,
			value: _.id
		}))
    }

    get weightUnit(){
        switch(this.organization.country){
            case "US":
                return I18n.t('lbs')
            case "CA":
                return I18n.t('kg')
            default:
                return I18n.t('lbs')
        }
    }

    get organization(){
        return this.props.organization || {}
    }


    handleNewPatient(e){
        e.preventDefault()
        this.setState({
            newPatient: {}
        })
    }

    handleNewPatientCancel(e){
        e.preventDefault()
        this.setState({
            newPatient: ''
        })
    }

    handleNewPatientSubmit(values){
        let day =  dayjs() 
        const ageYears = values.ageYears
        if(ageYears != undefined){
            day = day.subtract(ageYears, 'year')
            delete values.ageYears
        }
        const ageMonths = values.ageMonths
        if(ageMonths != undefined){
            day = day.subtract(ageMonths, 'month')
            delete values.ageMonths
        }
        if(ageMonths != undefined || ageYears != undefined){
            values.birthday = day
        }

        this.setState({
            newPatient: ''
        })
        let patient = {
            ...values,
            id: `newPatient-${values.name.replace(/ /g, '-')}`,
            firstName: values.name
        }

        PatientActions.append(patient)

        this.handlePatientSelect(patient)
    }

    handlePatientSelect(patient){
        this.setState({})
        this.props.onPatientSelect && this.props.onPatientSelect(patient)
    }

    patientsToCreate(){
        let numNewPets = this.patients.length
        let count = this.props.filters.patientCount - numNewPets
        if(count <= 0 && this.state.newPatient){
            count = 1
        }
        return count
    }

	render(){
        const {Form, InputDark, SelectDark, FormData} = this.props

		return (
            <div>
                {(this.patientsToCreate() > 0 || this.newPatient) ?
                    <div>
                        {times(this.patientsToCreate()).map((i)=>{
                            return (
                                <Container key={`new-patient-container-${this.newPatientCount + i}`} >
                                    <Form onSubmit={this.handleNewPatientSubmit}>
                                        <InputDark 
                                            required={true} 
                                            name='name' 
                                            type='text' 
                                            question='Name' 
                                            class={style.newPatientField} 
                                            initialValue={''}
                                        />
                                        {this.hasRestrictions && (
                                            <div>
                                                <label>Years</label>
                                                <InputDark 
                                                    required={true}
                                                    id='ageYears'
                                                    name='ageYears'
                                                    type='number'
                                                    min="0"
                                                    question={I18n.t("ageYears")}
                                                    class={style.newPatientField}
                                                    initialValue={''}
                                                />
                                            </div>
                                        )}
                                        {this.hasRestrictions && (
                                            <div>
                                                <label>Months</label>
                                                <InputDark 
                                                    required={true}
                                                    id='ageMonths'
                                                    name='ageMonths'
                                                    type='number'
                                                    min="0"
                                                    question={I18n.t("ageMonths")}
                                                    class={style.newPatientField}
                                                    initialValue={''}
                                                />
                                            </div>
                                        )}
                                        {this.hasRestrictions && 
                                            <InputDark 
                                                required={true} 
                                                type='number' 
                                                min="0" 
                                                name='weight' 
                                                question={`${I18n.t("weight")} (${this.weightUnit})`} 
                                                class={style.newPatientField} 
                                                initialValue={''}
                                            />
                                        }
                                        <SelectDark 
                                            required={true} 
                                            data={this.classifications} 
                                            name='classificationID' 
                                            placeholder='Species' 
                                            class={style.newPatientField} 
                                            value={''} 
                                            style={{marginBottom: '10px'}}
                                        />
                                        {this.hasRestrictions && 
                                            <SelectDark 
                                                required={true} 
                                                data={this.genders} 
                                                name='genderID' 
                                                placeholder='Gender' 
                                                class={style.newPatientField} 
                                                value={''} 
                                                style={{marginBottom: '10px'}}
                                            />
                                        }
                                        <div class={style.newPatientButtonContainer}>
                                            {this.patientsToCreate() == 0 &&
                                                <Button onClick={this.handleNewPatientCancel}>Cancel</Button>
                                            }
                                            <Button class={style.newPatientButton}>Submit</Button>
                                        </div>
                                    </Form>
                                </Container>
                            )
                        })}
                    </div>
                :
                    <Container key="new-patient-prompt" class={style.newPatient} onClick={this.handleNewPatient}>
                        + <I18n>addNewPatient</I18n>
                    </Container>
                }
                
                {this.patientsReversed.map((patient, i)=>{
                    const selected = Object.keys(this.props.selectedPatients).indexOf(patient.id) != -1
                    return (
                        <PatientSelectCard 
                            {...patient}
                            selected={!!selected}
                            onSelect={this.handlePatientSelect.bind(null, patient)} 
                        />
                    )
                })}
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/partials/PatientSelect/PatientSelectVertical.js